import e from"styled-components";const t=e.div`
	position: relative;
`,i=e.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
	gap: 5px;
	align-items: center;
	font-weight: 600;
	font-size: 14px;
`,n=e.div`
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	aspect-ratio: 1;
	border-radius: 50%;
	box-shadow: inset 0 0 1px #00000080;
	color: ${({text:e})=>e};
	background: ${({accent:e})=>e};

	${({isSelected:e,theme:t})=>e?`\n        outline: 2px solid ${t.text.brand}4d;\n        outline-offset: 1px;\n      `:"outline:none;"}

	&:hover {
		filter: brightness(0.96);
	}
`;export{n as ColorTile,i as ColorTilesContainer,t as ComponentWrapper};
